import {useState, useCallback} from "react";
import axios from "axios";
import { config } from "../../config/envs";
import { generateTraceId } from "../helpers";

export const useImpersonate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const impersonate = useCallback(async (email, options) => {
    setIsLoading(true);
    setError(null);

    

    try {
      const impersonateEndPoint = config.app.adminBaseUrl + "/auth/impersonate";

      const response = await axios.post(impersonateEndPoint, {
        email
      },
      {
        headers: {
          "x-trace-id": generateTraceId()
        }
      }
      );

      const {accessToken, expiresAt, adminEmail} = response.data;

      if (options?.onSuccess) {
        options.onSuccess(accessToken, expiresAt, adminEmail);
      }

    } catch (err) {
      setError(err);

      if (options?.onError) {
        options.onError(err);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {impersonate, isLoading, error };
};